import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from 'web-library';
import React, { useState } from 'react';


const ErrorModal = () => {
  const [modelOpen, setModelOpen] = useState(true);
  const closeModal = () => {
    setModelOpen(false);
  };
  return (
    <Dialog open={modelOpen} maxWidth="sm" state="error">
      <DialogContent>
        <DialogContentText>Error</DialogContentText>
        <DialogContentText>Please Retry.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button type="button" variant="text" color="secondary" onClick={() => closeModal()}>
          Retry
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
